<template>
  <div style="width: 100%;height: 100%;">
    <div id="async-script-loading" v-if="!loaded"></div>
    <slot v-if="loaded && !err"></slot>
    <div v-if="err">oops, something wrong</div>
  </div>
</template>

<script>
/**
 * 支持异步加载 js 并提供缓存
 * url 页面标题
 */
import { Loading } from 'element-ui';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { loadScript, loadStyle } from '../utils/index';

const URL_LOADED = {};

export default {
  props: {
    url: String,
    urls: Array,
    onLoad: {
      type: Function,
      default: function() {}
    }
  },
  data() {
    return {
      err: null,
      loaded: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async load(url) {
      if (URL_LOADED[url]) {
        return;
      }
      if (url.indexOf('.css') !== -1) {
        loadStyle(url);
      } else {
        await loadScript(url);
      }
      URL_LOADED[url] = true;
    },
    async loadUrls(urls) {
      if (isEmpty(urls)) return;
      for (let i = 0; i < urls.length; i++) {
        await this.load(urls[i]);
      }
    },
    async init() {
      const loading = Loading.service({
        target: '#async-script-loading'
      });
      try {
        await Promise.all(
          this.urls.map(url => {
            if (isArray(url)) {
              return this.loadUrls(url);
            }
            return this.load(url);
          })
        );
      } catch (e) {
        console.error(e);
        this.err = e;
      }
      loading.close();
      this.loaded = true;
      this.$nextTick(() => this.onLoad());
    }
  }
};
</script>

<style lang="less">
#async-script-loading {
  height: 300px;
  width: 100%;
}
</style>
